import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import {
	NotEnoughKeyNotification,
	NotEnoughTicketNotification,
	NotificationType,
} from '@mos/api/notification/dto-client'
import { MosResponse } from '@mos/shared/auth'
import { catchError, map, Observable } from 'rxjs'
import { ApiNotificationService } from './api-notification.service'

export const apiNotificationInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
	const apiNotificationService = inject(ApiNotificationService)

	return next(req).pipe(
		map((response) => {
			if (response instanceof HttpResponse && response.body) {
				const notifications = (response.body as MosResponse<unknown>).metadata?.notifications
				notifications?.forEach((notification) => apiNotificationService.dispatch(notification))
			}
			return response
		}),
		catchError((error) => {
			switch (error.error.cause) {
				case NotificationType.NOT_ENOUGH_TICKET:
					apiNotificationService.dispatch(new NotEnoughTicketNotification())
					break
				case NotificationType.NOT_ENOUGH_MEMORY_KEY:
					apiNotificationService.dispatch(new NotEnoughKeyNotification())
					break
			}
			throw error
		}),
	)
}
